export const googleMapApiKey = 'AIzaSyBVq-Y6aY9U6SPSeQC6t0s9Ij06teXt0qY';
export const googleMapId = 'fd0abbc8f83a3b67';
export const googleMapVersion = '3.59';
